import React from 'react';
import { Button } from '@thd-olt-component-react/core-ui';

const ProfileInviteCandidateButton = ({
  invitable, addJob, removeJob, jobId, selected
}) => {

  const buttonOptions = {
    invitable: {
      onClick: () => addJob(jobId),
      dataTestId: 'bulk-invite-select-job',
      dark: true,
      outline: true,
      style: { fontWeight: '600', fontSize: '16px' },
      text: 'Invite to Apply'
    },
    selected: {
      onClick: () => removeJob(jobId),
      dataTestId: 'bulk-invite-deselect-job',
      dark: true,
      outline: true,
      style: { fontWeight: '600', fontSize: '16px', color: 'white', background: '#666' },
      text: 'Invite to Apply'
    },
    disabled: {
      dataTestId: 'bulk-invite-disabled',
      disabled: true,
      style: { fontWeight: '600', fontSize: '16px' },
      text: 'Invited or Applied'
    }
  };

  let button;

  if (selected) {
    button = buttonOptions.selected;
  } else if (invitable) {
    button = buttonOptions.invitable;
  } else {
    button = buttonOptions.disabled;
  }

  return (
    <div className="p2p-invite-candidate-modal__table-button">
      <Button
        onClick={button.onClick}
        data-testid={button.dataTestId}
        dark={button.dark}
        outline={button.outline}
        disabled={button.disabled}
        style={button.style}
      >
        {button.text}
      </Button>
    </div>
  );
};

export default ProfileInviteCandidateButton;
